import m from "../../geodata/es2015/maliHigh";
window.am4geodata_maliHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/maliHigh.js
// module id = null
// module chunks = 